import { render, staticRenderFns } from "./Active.vue?vue&type=template&id=4c50157f"
import script from "./Active.vue?vue&type=script&lang=js"
export * from "./Active.vue?vue&type=script&lang=js"
import style0 from "./Active.vue?vue&type=style&index=0&id=4c50157f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports